import React, { memo } from 'react'

import PanelIcon from 'components/CommonUI/svgIcons/PanelIcon'
import { equal } from 'utils/memoEqual'

const PanelItem = ({ data, handleClick }) => {
  const { name = '', description = '', status = null } = data

  const classNameByStatus =
    status === 'connected' ? 'connected' : status === 'warning' ? 'warning' : ''

  return (
    <div className="panel_item_container">
      <div
        className={`panel_item_wrap ${classNameByStatus}`}
        onClick={handleClick}
      >
        <div className="names_section">
          <PanelIcon className="panel_icon" color={'rgba(21, 31, 49, 0.8)'} />
          <span className="name">{name}</span>
        </div>
        <div className="description_section">
          {description ? (
            <span className="description">{description}</span>
          ) : (
            <span className="no_description">No description</span>
          )}
        </div>
      </div>
    </div>
  )
}

export default memo(PanelItem, equal)
